module.exports = __webpack_public_path__ + "img/paragraph-left.6dfafc9a.svg";